import React from 'react';
import Spinner, { SpinnerOverlayContent } from 'Components/Spinner';
import Loadable from 'react-loadable';

export default function asyncComponent(importComponent) {
  const Loading = () => (
    <SpinnerOverlayContent>
      <Spinner />
    </SpinnerOverlayContent>
  );
  return Loadable({
    loader: importComponent,
    loading: Loading,
  });
}
